import { firebase } from 'src/firebase';
import { ReferenceError, InternalError } from 'src/firebase/db/ApplicationError';
import DatabaseAdapter from 'src/firebase/db/DatabaseAdapter';
import { ShopEntity } from './Shops';
/**
 *
 * 管理運営者・店舗オーナー Schema
 *
 */
export enum UserRole {
  INVALID = 0,
  ADMIN = 1,
  MEMBER = 2,
  SHOP_OWNER = 5,
  SHOP_MEMBER = 10,
}

export const adminInitialEntity = {
  role: 0 as UserRole,
  uid: '',
  shop_ids: [] as string[],
  shops: [] as ShopEntity[],
};
export type AdminEntity = typeof adminInitialEntity;

export type requiredSignInProps = {
  email: string;
  password: string;
};
class AdminsDB extends DatabaseAdapter {
  async signIn({ email, password }: requiredSignInProps) {
    return await firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(async (res: firebase.auth.UserCredential) => {
        if (res.user) {
          const user = await this.findUser(res.user.uid);
          return user;
        }
        throw new InternalError('system error');
      })
      .catch((err) => {
        switch (err.code) {
          case 'auth/user-not-found':
            throw new ReferenceError(err.message);
          default:
            throw new ReferenceError(err.message);
        }
      });
  }

  signOut() {
    return firebase.auth().signOut();
  }

  findUser = async (uid: string) => {
    return await this.getConnection()
      .where('uid', '==', uid)
      .get()
      .then(async (snapshot) => {
        if (snapshot.empty) {
          throw new ReferenceError('No matching documents.');
        }
        let user;
        await Promise.all(
          snapshot.docs.map(async (doc) => {
            const shops: ShopEntity[] = [];
            const { shops_ref } = doc.data();
            const ids = this.extractIdFromRef(shops_ref);
            await Promise.all(
              ids.map(async (id) => {
                if (id) {
                  const shopDocRef = this.getConnection('shops').doc(id);
                  await shopDocRef.get().then((doc) => {
                    if (doc.exists) {
                      const d = doc.data() as ShopEntity;
                      shops.push(d);
                    }
                  });
                }
              }),
            );

            user = {
              ...doc.data(),
              shop_ids: ids,
              shops,
            } as AdminEntity;
          }),
        );
        return this.formatSuccess(user);
      })
      .catch((err) => {
        console.log(err);
        if (err instanceof ReferenceError) {
          throw err;
        } else {
          throw new InternalError(err.message);
        }
      });
  };

  /**
   * パスワードリセットメールを送信する
   */
  sendPasswordResetEmail(email: string) {
    firebase.auth().languageCode = 'ja';
    return firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        return this.formatSuccess({
          message: 'success',
        });
      })
      .catch((err) => {
        throw new InternalError(err.message);
      });
  }
  /**
   *
   */
}

export default new AdminsDB({
  schema: 'admins',
});
